/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Ranking_OffInputs */

const en_us2_clubs_ranking_off = /** @type {(inputs: Clubs_Ranking_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No ranking: each person sees their own number and the group's total.`)
};

const pt_br2_clubs_ranking_off = /** @type {(inputs: Clubs_Ranking_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ranking: cada um vê o próprio número e o total do grupo.`)
};

const es_419_clubs_ranking_off = /** @type {(inputs: Clubs_Ranking_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin ranking: cada uno ve su propio número y el total del grupo.`)
};

const pt_pt2_clubs_ranking_off = /** @type {(inputs: Clubs_Ranking_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem classificação: cada um vê o seu número e o total do grupo.`)
};

const fr_fr2_clubs_ranking_off = /** @type {(inputs: Clubs_Ranking_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans classement : chacun voit son propre chiffre et le total du groupe.`)
};

const de_de2_clubs_ranking_off = /** @type {(inputs: Clubs_Ranking_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Rangliste: Jede Person sieht ihre eigene Zahl und die Summe der Gruppe.`)
};

const it_it2_clubs_ranking_off = /** @type {(inputs: Clubs_Ranking_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna classifica: ognuno vede il proprio numero e il totale del gruppo.`)
};

/**
* | output |
* | --- |
* | "No ranking: each person sees their own number and the group's total." |
*
* @param {Clubs_Ranking_OffInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_ranking_off = /** @type {((inputs?: Clubs_Ranking_OffInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Ranking_OffInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_ranking_off(inputs)
	if (locale === "es-419") return es_419_clubs_ranking_off(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_ranking_off(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_ranking_off(inputs)
	if (locale === "de-DE") return de_de2_clubs_ranking_off(inputs)
	if (locale === "it-IT") return it_it2_clubs_ranking_off(inputs)
	return en_us2_clubs_ranking_off(inputs)
});
export { clubs_ranking_off as "clubs.ranking_off" }